<div class="file-upload">
  <div class="card">
    <!-- <ng-container *ngIf="uploadingType==='dynamic'"> -->
    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="static-1">
      <ngb-panel id="static-1">
        <ng-template ngbPanelTitle class="p-0 m-0">
          <div class="card-header d-flex justify-content-between py-2">
            <p class="m-0 file-title d-flex"> <ng-container> <span>{{uploadProgress.file_type}} </span> <span>
                  {{uploadProgress.status == 'SUCCESS' ?
                  ' Uploaded':' Uploading'}}</span> </ng-container>
              <!-- <ng-container *ngIf="uploadProgress.file_type != 'XML File'"> {{uploadProgress.label}} </ng-container> -->
              <!-- <p class="m-0 file-title d-flex">{{!socketName?'XML':'PR Finalize'}} File {{ ' '}} <span
                *ngIf="uploadProgress.status != 'SUCCESS'">
                Uploading</span> <span *ngIf="uploadProgress.status == 'SUCCESS'"> Uploaded</span> -->
              <span class="tick-mark" *ngIf="uploadProgress.status != 'SUCCESS' && !hasPurchaseErrors.message">
                <div class="box">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </span>
              <span class="tick-mark" *ngIf="uploadProgress.status == 'SUCCESS'"><img height="22" class="rounded-circle"
                  src="assets/images/submittedicon.png" alt=""></span>
            </p>
            <button type="button" class="close text-white" data-dismiss="modal" (click)="close()">
              <i class="ri-arrow-down-s-line"></i>
            </button>
            <button
              *ngIf="uploadProgress.status == 'SUCCESS' || hasPurchaseErrors.message || uploadPurchaseProgress.completed || socketName"
              type="button" class="close2 text-white" data-dismiss="modal" (click)="uploadClose()">
              <i class="ri-close-line"></i>
            </button>
          </div>

        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card p-0" *ngIf="!isPurchaseSocket">
            <div class="card-body p-0">
              <div class="p-3" *ngIf="uploadProgress.status == 'STARTED' || uploadProgress.status == 'ERROR'">
                <!-- <h2 class="text-center p-5">{{uploadProgress.label}}</h2> -->
                <div class="d-flex">
                  <small
                    class="justify-content-between align-items-center"><b>{{excelUploadData.createdCount}}/{{excelUploadData.totalCount}}</b></small>
                </div>
                <div *ngIf="uploadProgress.status !== 'SUCCESS'">
                  <ngb-progressbar [animated]="true" [title]="'progress bar'" [type]="uploadProgress.color"
                    textType="white" [value]="uploadProgress.progress" [showValue]="true">
                  </ngb-progressbar>
                </div>

                <div class="mt-5 text-rightg" *ngIf="uploadProgress.status == 'ERROR'">
                  <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss()">Cancel</button>
                  <button type="button" class="btn btn-primary ml-2"
                    (click)="uploadProgress.status = 'NO'; uploadProgress.progress = 1;uploadProgress.color='secondary'">Retry</button>
                </div>
              </div>
              <div *ngIf="(uploadProgress.status === 'SUCCESS' && !uploadProgress?.data?.length)">
                <h6 class="text-center text-success mt-2">File Uploaded Successfully </h6>
              </div>
              <div class="p-2" *ngIf="uploadProgress.status == 'SUCCESS' && uploadProgress?.data?.length">
                <div class="d-flex py-2 bg-light justify-content-around" *ngFor="let each of uploadProgress.data">
                  <div class="p-2">
                    <small class="">Invoice Date</small>
                    <p class="font-weight-bold mb-0">{{each.date}}</p>
                  </div>
                  <div class="p-2">
                    <small class="font-weight-normal">Count</small>
                    <p class="font-weight-bold mb-0">{{each.invoice_number}}</p>
                  </div>
                  <div class="p-2">
                    <small class="font-weight-normal">Pending</small>
                    <p class="font-weight-bold mb-0">{{each.Pending}}</p>
                  </div>
                  <div class="p-2">
                    <small class="font-weight-normal">Success</small>
                    <p class="font-weight-bold mb-0">{{each.Success}}</p>
                  </div>
                  <div class="p-2">
                    <small class="font-weight-normal">Error</small>
                    <p class="font-weight-bold mb-0">{{each.Error}}</p>
                  </div>
                  <div class="p-2">
                    <small class="font-weight-normal">Zero</small>
                    <p class="font-weight-bold mb-0">{{each["Zero Invoice"]}}</p>
                  </div>
                  <!-- <div class="p-2 align-self-center">
                          <button class="btn btn-outline-primary">View</button>
                        </div> -->
                </div>
                <div class="mt-4 text-right">
                  <!-- <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss()">Close</button> -->
                  <button type="button" class="btn btn-primary ml-2" (click)="modal.dismiss()"
                    [routerLink]="['','home','upload-invoice']">View</button>
                </div>
              </div>
            </div>
          </div>

          <div class="card p-0" *ngIf="isPurchaseSocket">
            <div class="card-body p-0">
              <div class="p-3" *ngIf="uploadPurchaseProgress.status == 'STARTED'">
                <!-- <h2 class="text-center p-5">{{uploadPurchaseProgress.label}}</h2> -->
                <div class="d-flex">
                  <small
                    class="justify-content-between align-items-center"><b>{{purchaseExcelUploadData.createdCount}}/{{purchaseExcelUploadData.totalCount}}</b></small>
                </div>
                <div *ngIf="uploadPurchaseProgress.status !== 'SUCCESS'">
                  <ngb-progressbar [animated]="true" [title]="'progress bar'" [type]="uploadPurchaseProgress.color"
                    textType="white" [value]="uploadPurchaseProgress.progress" [showValue]="true">
                  </ngb-progressbar>
                </div>
                <div *ngIf="uploadPurchaseProgress.status === 'SUCCESS'">
                  <h6 class="text-center text-success mt-2">Files Uploaded Successfully </h6>
                </div>
                <div class="mt-5 text-right" *ngIf="uploadPurchaseProgress.status == 'ERROR'">
                  <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss()">Cancel</button>
                  <button type="button" class="btn btn-primary ml-2"
                    (click)="uploadPurchaseProgress.status = 'NO'; uploadPurchaseProgress.progress = 1;uploadPurchaseProgress.color='secondary'">Retry</button>
                </div>
              </div>
              <ng-container *ngIf="uploadPurchaseProgress.status == 'ERROR'">
                <div class="d-flex align-items-center gap-5 m-2">
                  <i class="ri-error-warning-fill text-danger"></i>
                  <span class="d-flex flex-column">
                    {{hasPurchaseErrors?.message}}</span>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="card p-0" *ngIf="socketName">
            <div class="card-body p-0">
              <h6 class="text-center text-success mt-2">File Uploaded Successfully </h6>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
    <!-- </ng-container> -->

  </div>
</div>